import { ShieldX } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { Alert, AlertDescription } from './ui/alert';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';

interface AccessDeniedProps {
  message?: string;
  showBackButton?: boolean;
}

export function AccessDenied({
  message = 'Você não tem permissão para acessar este recurso.',
  showBackButton = true,
}: AccessDeniedProps) {
  const navigate = useNavigate();

  return (
    <Card className="mx-auto max-w-md mt-12">
      <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-destructive/10">
          <ShieldX className="h-7 w-7 text-destructive" />
        </div>
        <Alert variant="destructive">
          <AlertDescription>{message}</AlertDescription>
        </Alert>
        {showBackButton && (
          <Button variant="outline" onClick={() => navigate(-1)}>
            Voltar
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
